import Cookies from 'js-cookie'
// import constant from '@/config/constant'
import AuthService from '@/services/Auth'

export default {
  async login(context, payload) {
    const { dispatch } = context

    try {
      const token = payload.accessToken
      const countryCode = payload.countryCode

      if (!token) {
        console.error('Token inválido ou expirado')
        await dispatch('logout')
        return
      }

      // Obtem os dados do user e account
      await AuthService.getUserAndAccount(token, countryCode).then(
        async (response) => {
          await dispatch('Account/setAccount', response.data.res_data.account, {
            root: true
          })

          await dispatch(
            'Account/setAccounts',
            response.data.res_data.linked_accounts,
            { root: true }
          )

          await dispatch('setAuthUser', response.data.res_data.user)

          Cookies.set('auth-user', response.data.res_data.user?.name, {
            expires: 1
          })

          localStorage.setItem(
            'theme-color',
            response.data.res_data.user?.current_theme
          )
        }
      )
    } catch (err) {
      console.error('Login action error:', err)
      await dispatch('logout')
    }
  },

  setAuthUser(context, user) {
    context.commit('authSetUser', user)
  },

  logout(context) {
    context.commit('authLogout')
  }
}
